import { MdCheck } from "react-icons/md";
import styles from "./CheckList.module.css";

interface Props {
  items: Array<string>;
  checkmarkColor: string;
}

export default function CheckList({ items, checkmarkColor }: Props) {
  return (
    <ul className={styles.CheckList}>
      {items.map((item, index) => (
        <li key={index}>
          <span className={styles.CheckListIcon}>
            <MdCheck color={checkmarkColor} />
          </span>
          {item}
        </li>
      ))}
    </ul>
  );
}
